var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSamsung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.64 11.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed008e;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo samsung") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.48,5.14a9.75,9.75,0,0,0-1.19-.63,9.45,9.45,0,0,1-1.69-1,1,1,0,0,1-.23-1.12A.7.7,0,0,1,39.09,2s.76,0,.76.66v.88h2.71V2.29S42.75.17,39.35.08c0,0-2.67-.18-3.44,1.26,0,0-.3.32-.3,1.44v.81a2.67,2.67,0,0,0,.45,1.53,3.51,3.51,0,0,0,.93.83s1.35.73,2.15,1.14c0,0,.82.47.71,1.21A.8.8,0,0,1,39,9a.75.75,0,0,1-.72-.78V7.37H35.4V8.64s-.08,2.43,3.63,2.43c0,0,3.54.07,3.71-2.49v-1a2.7,2.7,0,0,0-1.25-2.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.62 0.38 26.71 6.06 26.5 6.06 25.64 0.43 21.11 0.43 20.89 10.72 23.57 10.72 23.6 2.97 23.81 2.97 25.23 10.72 28.04 10.72 29.44 2.97 29.63 2.97 29.7 10.72 32.39 10.72 32.1 0.38 27.62 0.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.69 0.42 9.9 10.71 12.79 10.71 13.84 2.73 14.08 2.73 15.13 10.71 18.01 10.71 16.23 0.42 11.69 0.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.15,5V6.52h.74V8.15a.74.74,0,1,1-1.48.05V2.57c0-.58.73-.61.73-.61a.69.69,0,0,1,.71.69v.86h2.71c.09-1.67-.24-2.08-.24-2.08C74.66-.08,72.11,0,72.11,0c-3.91,0-3.48,3-3.48,3V8.45c.08,2.82,3.94,2.53,4,2.53a3.8,3.8,0,0,0,2.23-.73,1.67,1.67,0,0,0,.6-.84,5,5,0,0,0,.17-1.2V5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.16 6.67 63.04 6.67 60.29 0.39 56.99 0.39 56.99 10.72 59.67 10.72 59.52 4.43 59.63 4.43 62.49 10.72 65.68 10.72 65.68 0.38 62.97 0.38 63.16 6.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.45,8.14s0,.85-.75.85a.78.78,0,0,1-.83-.83V.39H45.93V8.1S45.62,11,49.74,11c0,0,3.58,0,3.58-2.79V.39H50.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.08,5.14a9.74,9.74,0,0,0-1.19-.63,9.34,9.34,0,0,1-1.69-1A1,1,0,0,1,3,2.43.7.7,0,0,1,3.69,2s.76,0,.76.66v.88H7.15V2.28S7.35.17,4,.08c0,0-.26,0-.63,0,0,0-2.06.11-2.79,1.24l0,0s-.3.32-.3,1.44v.81A2.67,2.67,0,0,0,.67,5.12a3.51,3.51,0,0,0,.93.83s1.35.73,2.15,1.14c0,0,.82.46.71,1.21A.8.8,0,0,1,3.61,9a.75.75,0,0,1-.72-.78V7.37H0V8.64s-.08,2.43,3.63,2.43c0,0,3.54.07,3.71-2.49v-1a2.71,2.71,0,0,0-1.25-2.4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSamsung);
export default __webpack_public_path__ + "static/media/logo-samsung.840a4b3f4dec795c35ca10320789cd4b.svg";
export { ForwardRef as ReactComponent };